import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from "@mui/material";
import {useState} from "react";
import {NewTokenRequest} from "../entities/new-token-request";

export interface TokenRequestDialogProps {
    isOpen: boolean;
    onClose: (newTokenRequest?: NewTokenRequest) => void;
}

export const TokenRequestDialog = ({isOpen, onClose}: TokenRequestDialogProps) => {

    const [amount, setAmount] = useState(0);
    const [proof, setProof] = useState<File>();

    return <Dialog open={isOpen} onClose={() => onClose()}>
        <DialogTitle>Request additional tokens</DialogTitle>
        <DialogContent>
            <Typography>
                To request more tokens, please fill the following form. You must submit a proof of payment (pdf, png,
                jpg)
            </Typography>
            <form>
                <TextField value={amount} type={"number"} placeholder="Number of tokens" name="amount"
                           label="Number of tokens" fullWidth sx={{marginTop: "1rem"}}
                           onChange={(ev) => setAmount(Number.parseInt(ev.target.value))}/>
                <div style={{marginTop: "1rem"}}>
                    <Button
                        variant="contained" fullWidth
                        component="label"
                    >
                        {proof !== undefined ? proof.name : "Upload proof of payment"}
                        <input
                            type="file"
                            accept="image/png,image/jpeg,application/pdf"
                            name="proof"
                            onChange={(e) => {
                                if (e.target.files) {
                                    setProof(e.target.files[0])
                                }
                            }}
                            hidden
                        />
                    </Button>
                </div>
            </form>
        </DialogContent>
        <DialogActions>
            <Button color="error" onClick={() => onClose()}>Cancel</Button>
            <Button color="success" variant="contained" disabled={!proof || !amount || amount === 0} onClick={() => {
                onClose(new NewTokenRequest(amount, proof!!))
            }}>Request new tokens</Button>
        </DialogActions>
    </Dialog>
}